import { TitleCasePipe } from '@angular/common';
import { SimSubscription } from '../interfaces/sims';

export function esimPlanName(
  plan:
    | SimSubscription
    | {
        dataUsageAllowanceType: string;
        dataUsageAllowanceInGb: number;
        validity: number;
        cycleUnits: string;
      },
  countryName?: string
): string {
  const transformPipe = new TitleCasePipe();
  const cycleUnits = transformPipe.transform(plan.cycleUnits === 'day' ? 'Days' : plan.cycleUnits);
  const dataUsage =
    plan.dataUsageAllowanceType === 'UNLIMITED' ? 'Unlimited' : `${plan.dataUsageAllowanceInGb}GB`;
  const country = countryName ?? ('country' in plan ? plan.country : '');
  return `${country} ${dataUsage} / ${plan.validity} ${cycleUnits}`;
}
